import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { ProductClass } from "../../../../core/json/ProductClass";
import {
  addNewProduct,
  getGroupEntryByGuid,
  getModifierList,
  getProductTypeguid,
  getUnitguid,
} from "../../../../services/MasterApiServices";
import toast from "react-hot-toast";
import Select, { components } from "react-select";

const ModifierOption = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      className="me-2"
    />
    <label className="mb-0">{props.label}</label>
  </components.Option>
);

const SelectedCountValueContainer = ({ children, ...props }) => {
  const selected = props.getValue();
  const [, inputChild] = children;
  return (
    <components.ValueContainer {...props}>
      {selected.length > 0 ? (
        <span className="text-truncate">{selected.length} selected</span>
      ) : (
        !props.selectProps.inputValue && (
          <span className="text-muted">{props.selectProps.placeholder}</span>
        )
      )}
      {inputChild}
    </components.ValueContainer>
  );
};

function AddOtherDescription({ register, errors, modifierList, control,watch,setValue }) {
  const { branch } = useSelector((state) => state.branchlist);
  const { product, productsection } = useSelector((state) => state.productdata);
    const [modifiers, setModifiers] = useState([]);

const modifierOptions = modifierList.map((modifier) => ({
    value: modifier.guid, 
    label: modifier.name,
  }));
  const handleModifiers = (modifierOptions) => {
    setModifiers(modifierOptions || []);  
  }
  console.log("modifierOptions", modifierOptions);

  const isStockItem = watch("isStockItem");
  const isDailyStockItem = watch("isDailyStockItem");

  // 👇 Automatically uncheck Daily Stock when Is Stock Item is unchecked
  useEffect(() => {
    if (!isStockItem && isDailyStockItem) {
      setValue("isDailyStockItem", false);
    }
  }, [isStockItem, isDailyStockItem, setValue]);

  return (
    <div>
      <div>
        <div className="modal-body custom-modal-body">
          <div className="branch-tabs col-12 align-items-center justify-content-between">
            {Object.keys(errors || {})
              .map((key) => errors[key]?.message)
              .find(Boolean) && (
              <span className="error text-danger text-sm">
                {Object.keys(errors || {})
                  .map((key) => errors[key]?.message)
                  .find(Boolean)}
              </span>
            )}
          </div>

          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="col-auto input-blocks">
                <label className="col-form-label">Other Description</label>
              </div>
              <div className="col input-blocks mb-3">
                <input
                  type="text"
                  className="form-control"
                  {...register("otherDescription")}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="col-auto input-blocks">
                <label className="col-form-label">Calories</label>
              </div>
              <div className="col input-blocks mb-3">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Calories"
                  {...register("calories")}
                />
              </div>
            </div>
            <div className=" col-md-6 col-sm-12">
              <div className="col-auto input-blocks ">
                <label className="col-form-label">HSN code</label>
              </div>
              <div className="col input-blocks mb-3">
                <input
                  type="text"
                  id=""
                  className="form-control"
                  {...register("hsnCode")}
                />
              </div>
            </div>

         {/* <div className="col-md-6 col-sm-12">
         <label>Select section</label>
                                   <Select
                                     closeMenuOnSelect={false}
                                     isMulti
                                
                                     placeholder="Select modifiers"
                                     value={modifiers}
                                     onChange={handleModifiers}
                                     options={modifierOptions}
                                     menuPortalTarget={document.body} // Render dropdown in the body
                                     styles={{
                                       menuPortal: (base) => ({
                                         ...base,
                                         zIndex: 9999, // Ensure it appears above other elements
                                       }),
                                     }}
                                   />
        </div> */}
         <div className="col-md-6 col-sm-12 mb-3">
            <label>Select Modifiers</label>
            <Controller
              name="modifiers"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  controlShouldRenderValue={false}
                  isMulti
                  placeholder="Select modifiers"
                  options={modifierOptions}
                  components={{ Option: ModifierOption, ValueContainer: SelectedCountValueContainer }}
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base) => ({ ...base, minHeight: 40, overflow: "hidden" }),
                    valueContainer: (base) => ({ ...base, flexWrap: "nowrap", overflow: "hidden" }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              )}
            />
          </div>

          </div>

          <div className="row">
            <div className="col-lg-3 col-sm-12">
              <input
                type="checkbox"
                className=""
                {...register("isRateVaryProduct")}
              />{" "}
              Is product price variable?
            </div>
            <div className="col-lg-9  col-sm-12 general_decription">
              When this setting enabled, we can change the price of product
              while billing, a popup box will show in sales screen
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-3 col-sm-12">
              <input
                type="checkbox"
                className=""
                {...register("isDailyStockItem")}
              />
              Daily Stock Item
            </div>
            <div className="col-lg-9  col-sm-12 general_decription">
              When this setting enabled, this product is considered as a stock
              product which will be shown in stock product
            </div>
          </div> */}
                  {/* ✅ New Is Stock Item checkbox */}
        <div className="row">
          <div className="col-lg-3 col-sm-12">
            <input type="checkbox" className="" {...register("isStockItem")} />{" "}
            Is Stock Item
          </div>
          <div className="col-lg-9 col-sm-12 general_decription">
            When enabled, this product will be treated as a stock item.
          </div>
        </div>

           {/* 👇 Daily Stock Item always visible, but disabled when Is Stock Item = false */}
        <div className="row">
          <div className="col-lg-3 col-sm-12">
            <input
              type="checkbox"
              {...register("isDailyStockItem")}
              disabled={!isStockItem} // 👈 disables when false
            />{" "}
            Daily Stock Item
          </div>
          <div
            className={`col-lg-9 col-sm-12 general_decription ${
              !isStockItem ? "text-muted" : ""
            }`}
          >
            When enabled, this product is considered a daily stock product.
          </div>
        </div>
          <div className="col-lg-12"></div>
        </div>
      </div>
    </div>
  );
}

export default AddOtherDescription;
